import { Box, Button, Stack, Typography } from "@mui/material";
import { GridColDef, GridRowsProp } from "@mui/x-data-grid-premium";
import { forwardRef } from "react";
import Modal, { CommonModalProps } from "..";
import { StatusHistoryModalDto } from "../../../Core/Api/Types/db-object-status-history-infos";
import AssetStatus from "../../Misc/Status/AssetStatus/asset-status";
import DataTable, { CellSize } from "../../Table/table";
import TableCellDateTime from "../../Table/TableCellDateTime/table-cell-date-time";
import { useTranslation } from "react-i18next";

export type ModalStatusHistoryElementProps = {
  assetId: number;
  historyData: StatusHistoryModalDto[];
};

export type ModalStatusHistoryProps = CommonModalProps<ModalStatusHistoryElementProps>;

const ModalStatusHistory = forwardRef<any, ModalStatusHistoryProps>((props, ref) => {
  const { t } = useTranslation();
  const { assetId, historyData, closeModal } = props;

  let _rows: GridRowsProp = [];
  type Row = (typeof _rows)[number];
  const gridDefinition: GridColDef[] = [
    {
      headerName: t("common:date"),
      field: "date",
      minWidth: CellSize.small,
      flex: CellSize.small,
      renderCell: (data: Row) => (
        <Box p={0.5}>
          <TableCellDateTime data={data} />
        </Box>
      ),
    },
    {
      headerName: t("common:status"),
      field: "status",
      renderCell: (data: Row) => <AssetStatus status={data.value} />,
      minWidth: CellSize.small,
      flex: CellSize.small,
    },
    {
      headerName: t("common:user"),
      field: "user",
      minWidth: CellSize.small,
      flex: CellSize.small,
    },
    {
      headerName: t("common:message"),
      field: "message",
      minWidth: CellSize.large,
      flex: CellSize.large,
      renderCell: (data: Row) => <Typography p={1}>{data.value}</Typography>,
    },
  ];

  return (
    <Modal
      reference={ref}
      title={t("modal:title.assetStatusHistory", { assetId })}
      closeModal={closeModal}
      width={800}
      footer={
        <Stack direction="row" justifyContent="flex-end">
          <Button variant="outlined" onClick={closeModal}>
            {t("common:close")}
          </Button>
        </Stack>
      }
    >
      <DataTable
        columns={gridDefinition}
        rows={historyData}
        pagination={false}
        getRowHeight={() => "auto"}
        disableRowSelectionOnClick
        initialState={{
          sorting: {
            sortModel: [{ field: "date", sort: "desc" }],
          },
        }}
      />
    </Modal>
  );
});

export default ModalStatusHistory;
